export const SITE = {
  name: 'Startup Idea Validator',
  // The TITLE SUFFIX, not an abbreviation of the product. It was 'SIV', and the founder's
  // rule is that the product is named in full wherever a customer can see it -- never the
  // initialism, same convention as the World Finance Terminal. Setting it to the full name
  // would make the home page read "Startup Idea Validator · Startup Idea Validator", so the
  // suffix is the owner: "Pricing · GodEngine", matching index.html.
  shortName: 'GodEngine',
  owner: 'GodEngine',
  tagline: 'A de-risking instrument for stated business ideas.',
  /** Set VITE_SITE_URL at build time; the fallback keeps local builds coherent. */
  url: (import.meta.env.VITE_SITE_URL ?? 'https://startupideavalidator.godengine.ai').replace(/\/$/, ''),
  auditDate: '2026-05-26',
  contactEmail: 'hello@godengine.example',
} as const;

export type NavItem = {
  label: string;
  to: string;
};

export const PRIMARY_NAV: NavItem[] = [
  { label: 'How it works', to: '/how-it-works' },
  { label: 'The report', to: '/report' },
  { label: 'Evidence standard', to: '/evidence-standard' },
  { label: 'Engine', to: '/engine' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'FAQ', to: '/faq' },
];

export const FOOTER_NAV: { heading: string; items: NavItem[] }[] = [
  {
    heading: 'Product',
    items: [
      { label: 'How it works', to: '/how-it-works' },
      { label: 'The report', to: '/report' },
      { label: 'Pricing', to: '/pricing' },
    ],
  },
  {
    heading: 'Method',
    items: [
      { label: 'Evidence standard', to: '/evidence-standard' },
      { label: 'Engine attestation', to: '/engine' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    heading: 'Company',
    items: [{ label: 'Contact', to: '/contact' }],
  },
];

export const MARQUEE_ITEMS = [
  'GodEngine Startup Idea Validator',
  'Evidence before opinion',
  'Threshold before verdict',
  'Source before number',
  'No score',
  'No vanity gauge',
];

/** The nine run stages, used on the home page and How it works. */
export const STAGES = [
  { id: 'S1', name: 'Decompose', blurb: 'Resolve · fetches nothing' },
  { id: 'S2', name: 'Extract', blurb: 'Resolve · fetches nothing' },
  { id: 'S3', name: 'Type', blurb: 'Resolve · fetches nothing' },
  { id: 'S4', name: 'Priors', blurb: 'Retrieval starts here' },
  { id: 'S5', name: 'Assemble', blurb: 'The causal graph' },
  { id: 'S6', name: 'Propagate', blurb: 'Forward dynamics' },
  { id: 'S7', name: 'Kill-lines', blurb: 'Where it stops working' },
  { id: 'S8', name: 'Structural', blurb: 'Allowed to disagree' },
  { id: 'S9', name: 'Emit', blurb: 'One envelope, one URL' },
] as const;
